module.exports = __webpack_public_path__ + "static/headShot-883c77cb6406e8b690da1bcb598c71d0.jpg";